/**
 * Компонент для отображения логов на экране (для мобильной отладки)
 */
import { useEffect, useState } from 'react'
import './DebugLogger.css'

interface LogEntry {
  timestamp: string
  type: 'log' | 'warn' | 'error'
  message: string
}

export function DebugLogger() {
  const [logs, setLogs] = useState<LogEntry[]>([])
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const originalLog = console.log
    const originalWarn = console.warn
    const originalError = console.error

    const addLog = (type: 'log' | 'warn' | 'error', args: any[]) => {
      const message = args.map(arg => {
        if (typeof arg === 'object') {
          try {
            return JSON.stringify(arg, null, 2)
          } catch {
            return String(arg)
          }
        }
        return String(arg)
      }).join(' ')

      const timestamp = new Date().toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        fractionalSecondDigits: 3
      })

      setLogs(prev => [...prev.slice(-50), { timestamp, type, message }])
    }

    console.log = (...args: any[]) => {
      originalLog(...args)
      addLog('log', args)
    }

    console.warn = (...args: any[]) => {
      originalWarn(...args)
      addLog('warn', args)
    }

    console.error = (...args: any[]) => {
      originalError(...args)
      addLog('error', args)
    }

    return () => {
      console.log = originalLog
      console.warn = originalWarn
      console.error = originalError
    }
  }, [])

  const clearLogs = () => {
    setLogs([])
  }

  const copyLogs = () => {
    const text = logs.map(log => `[${log.timestamp}] ${log.type.toUpperCase()}: ${log.message}`).join('\n')
    navigator.clipboard.writeText(text).then(() => {
      alert('Логи скопированы!')
    }).catch(() => {
      alert('Не удалось скопировать логи')
    })
  }

  if (!isVisible) {
    return (
      <div className="debug-logger__footer">
        <span className="debug-logger__copyright">
          © 2025 Комбинат Цифровых Решений
        </span>
        <a
          className="debug-logger__link"
          onClick={() => setIsVisible(true)}
        >
          Отладка
        </a>
      </div>
    )
  }

  return (
    <div className="debug-logger">
      <div className="debug-logger__header">
        <span className="debug-logger__title">🔍 Debug Logs ({logs.length})</span>
        <div className="debug-logger__buttons">
          <button onClick={copyLogs} className="debug-logger__button">
            📋 Копировать
          </button>
          <button onClick={clearLogs} className="debug-logger__button">
            🗑️ Очистить
          </button>
          <button onClick={() => setIsVisible(false)} className="debug-logger__button">
            ➖ Скрыть
          </button>
        </div>
      </div>
      <div className="debug-logger__content">
        {logs.length === 0 ? (
          <div className="debug-logger__empty">Нет логов</div>
        ) : (
          logs.map((log, index) => (
            <div key={index} className={`debug-logger__entry debug-logger__entry--${log.type}`}>
              <span className="debug-logger__timestamp">{log.timestamp}</span>
              <span className="debug-logger__message">{log.message}</span>
            </div>
          ))
        )}
      </div>
    </div>
  )
}









